import type RaygunType from 'raygun4js'

export const rg4js: typeof RaygunType =
  // When running on server side, window doesn't exist, but also raygun doesn't get
  // loaded. So with this workaround, if window isn't defined then we can mock raygun
  // out with just an empty function. But if window does exist, then we should have
  // a `rg4js` global which was loaded as part of the script injected in `_document.tsx`.
  // Additionally, we can avoid tu run raygun within Cypress tests.
  typeof window === 'undefined' || window.Cypress
    ? () => {}
    : (...args: any) => window.rg4js(...args)
